class AmountInput {
  /**
   * @param {HTMLInputElement} $el
   */
  constructor($el) {
    this.$el = $el;

    this.minimumAmount = parseFloat(this.$el.getAttribute('min') || 0);
  }

  addEventListener(...args) {
    return this.$el.addEventListener(...args);
  }

  removeEventListener(...args) {
    return this.$el.removeEventListener(...args);
  }

  setIsRequired(value) {
    if (value) {
      this.$el.setAttribute('required', '');
    } else {
      this.$el.removeAttribute('required');
    }
  }

  getState = () => {
    const { validity } = this.$el;
    const stringValue = this.$el.value;
    const badInput = !!validity.badInput;
    const valueMissing = validity.valueMissing;
    const rangeUnderflow = validity.rangeUnderflow;
    const isValid = !badInput && !valueMissing && !rangeUnderflow;

    let value;

    if (stringValue !== '') {
      value = parseFloat(stringValue);
    }

    return {
      isValid,
      badInput,
      valueMissing,
      rangeUnderflow,
      stringValue,
      value,
    };
  }
}


export default AmountInput;



// WEBPACK FOOTER //
// ./src/events/detail/AmountInput.js